import {
  variants_default
} from "./chunk.7OG3CMFN.js";
import {
  appearance_default
} from "./chunk.GO6CI477.js";
import {
  WebAwesomeElement,
  n,
  t
} from "./chunk.LVUMIIKQ.js";
import {
  ke
} from "./chunk.S3625EU6.js";
import {
  __decorateClass
} from "./chunk.SZE6ONST.js";

// src/components/badge/badge.css
var badge_default = ":host {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: max(var(--wa-font-size-2xs), 0.75em);\n  font-weight: var(--wa-font-weight-semibold);\n  line-height: 1;\n  background-color: var(--background-color, var(--wa-color-fill-loud));\n  border-color: var(--border-color, transparent);\n  border-radius: var(--wa-border-radius-s);\n  border-style: var(--wa-border-style);\n  border-width: var(--wa-border-width-s);\n  color: var(--text-color, var(--wa-color-on-loud));\n  white-space: nowrap;\n  padding: 0.375em 0.625em;\n  user-select: none;\n  -webkit-user-select: none;\n  cursor: inherit;\n}\n\n/* Pill modifier */\n:host([pill]) {\n  border-radius: var(--wa-border-radius-pill);\n}\n\n/* Pulse modifier */\n:host([pulse]) {\n  --pulse-color: var(--background-color);\n\n  animation: pulse 1.5s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 var(--pulse-color);\n  }\n  70% {\n    box-shadow: 0 0 0 0.5rem transparent;\n  }\n  100% {\n    box-shadow: 0 0 0 0 transparent;\n  }\n}\n\n::slotted(wa-icon) {\n  margin-inline-end: var(--wa-space-2xs, 0.25em);\n  opacity: 90%;\n  line-height: 1;\n  height: 0.85em;\n}\n";

// src/components/badge/badge.ts
var WaBadge = class extends WebAwesomeElement {
  constructor() {
    super(...arguments);
    this.variant = "inherit";
    this.appearance = "accent";
    this.pill = false;
    this.pulse = false;
  }
  render() {
    return ke` <slot part="base" role="status"></slot>`;
  }
};
WaBadge.shadowStyle = [variants_default, appearance_default, badge_default];
__decorateClass([
  n({ reflect: true, initial: "brand" })
], WaBadge.prototype, "variant", 2);
__decorateClass([
  n({ reflect: true })
], WaBadge.prototype, "appearance", 2);
__decorateClass([
  n({ type: Boolean, reflect: true })
], WaBadge.prototype, "pill", 2);
__decorateClass([
  n({ type: Boolean, reflect: true })
], WaBadge.prototype, "pulse", 2);
WaBadge = __decorateClass([
  t("wa-badge")
], WaBadge);

export {
  WaBadge
};
